const PRODUCT_ROOT_DOMAINS = {
  platform: {
    dev: 'app.loc',
    staging: 'app.test',
    prod: 'nucleop.app',
  },
  site: {
    dev: 'nucleop.loc',
    staging: 'nucleop.test',
    prod: 'nucleop.com',
  },
  admindigital: {
    dev: 'admindigital.loc',
    staging: 'admindigital.test',
    prod: 'admindigital.app',
  },
  dashconnect: {
    dev: 'dashconnect.loc',
    staging: 'dashconnect.test',
    prod: 'dashconnect.app',
  },
  artiflow: {
    dev: 'artiflow.loc',
    staging: 'artiflow.test',
    prod: 'artiflow.app',
  },
};

const AUTH_ROOT_DOMAINS = {
  dev: 'auth.app.loc',
  staging: 'auth.app.test',
  prod: 'auth.nucleop.app',
};
const ACTIVE_PRODUCT_CODES = ['platform', 'site', 'admindigital'];
const PRODUCTION_DOMAIN_SUFFIXES = ['.com.br', '.net.br', '.com', '.app', '.net'];

export function isProductionHost(host = '') {
  const hostname = String(host || '').trim().toLowerCase().replace(/\.$/, '');
  return PRODUCTION_DOMAIN_SUFFIXES.some((suffix) => hostname.endsWith(suffix));
}

export function normalizeAppEnv(appEnv = 'dev') {
  const env = String(appEnv || '').trim().toLowerCase();
  if (env === 'homolog') throw new Error('APP_ENV=homolog não existe; use staging.');
  if (['prod', 'production'].includes(env)) return 'prod';
  if (env === 'staging') return 'staging';
  return 'dev';
}

export function getEnvironmentProtocol(appEnv = 'dev') {
  const env = normalizeAppEnv(appEnv);
  return env === 'prod' || env === 'staging' ? 'https' : 'http';
}

export function getProductRootDomain(product = 'platform', appEnv = 'dev') {
  const normalizedProduct = String(product || 'platform').trim().toLowerCase();
  const normalizedEnv = normalizeAppEnv(appEnv);
  const productMap = PRODUCT_ROOT_DOMAINS[normalizedProduct] || PRODUCT_ROOT_DOMAINS.platform;
  return productMap[normalizedEnv];
}

export function getDomainHost(product = 'platform', domain = '', appEnv = 'dev') {
  const rootDomain = getProductRootDomain(product, appEnv);
  const normalizedDomain = String(domain || '').trim().toLowerCase();

  if (!normalizedDomain || ['app', 'root', 'www'].includes(normalizedDomain)) {
    return rootDomain;
  }

  return `${normalizedDomain}.${rootDomain}`;
}

export function getProductOrigin(product = 'platform', appEnv = 'dev') {
  return `${getEnvironmentProtocol(appEnv)}://${getProductRootDomain(product, appEnv)}`;
}

export function getProjectRootDomains(appEnv = 'dev') {
  const normalizedEnv = normalizeAppEnv(appEnv);
  return ACTIVE_PRODUCT_CODES.map((product) => PRODUCT_ROOT_DOMAINS[product][normalizedEnv]);
}

export function getAuthOrigin(appEnv = 'dev') {
  const normalizedEnv = normalizeAppEnv(appEnv);
  const resolvedEnv = AUTH_ROOT_DOMAINS[normalizedEnv] ? normalizedEnv : 'dev';
  return `${getEnvironmentProtocol(resolvedEnv)}://${AUTH_ROOT_DOMAINS[resolvedEnv]}`;
}

export function inferProductFromHost(host = '') {
  const normalizedHost = String(host || '').trim().toLowerCase();
  if (!normalizedHost) return '';

  for (const [product, envMap] of Object.entries(PRODUCT_ROOT_DOMAINS)) {
    const roots = Object.values(envMap);
    if (roots.some((root) => normalizedHost === root || normalizedHost.endsWith(`.${root}`))) {
      return product;
    }
  }

  return '';
}
